import React from 'react';
import { ButtonProps } from 'antd/lib/button';

import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import CcNode from '../../../services/models/CcNode';
import ButtonWithForm from '../../../common/General/ButtonWithForm';
import CcCluster from '../../../services/models/CcCluster';
import NodeChangeReplicationMasterForm from './NodeChangeReplicationMasterForm';
import JobActionButton from '../../Jobs/JobActionButton';

export default NodeChangeReplicationMasterButton;

export type NodeChangeReplicationMasterButtonProps = ButtonProps & {
    node: CcNode;
    cluster: CcCluster;
    children?: React.ReactNode;
    onSuccess?: () => void;
};

function NodeChangeReplicationMasterButton({
    node,
    cluster,
    children,
    onSuccess,
    ...rest
}: NodeChangeReplicationMasterButtonProps) {
    return (
        <ButtonWithForm
            button={
                <JobActionButton
                    command={CmonJobInstanceCommand.FAILOVER_REPLICATION_SLAVE}
                    clusterId={node.clusterid}
                    extraKey={[node.hostname, node.port]}
                    {...rest}
                >
                    {children || 'Change replication primary'}
                </JobActionButton>
            }
            form={
                <NodeChangeReplicationMasterForm
                    node={node}
                    cluster={cluster}
                    onSuccess={onSuccess}
                />
            }
        />
    );
}
